import axios from 'axios';

export const getRequest = async <T>(url: string) => {
  const response = await axios.get<T>(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return response.data;
};
